import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const NumeroDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NUM. DOC.' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='numeroDocumento'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-numeroDetraccion'
              isInvalid={iError && iTouched}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
